import { ReactNode } from "react";

import { OPTIONAL, REQUIRED } from "../../../constants/Text";

export const getPlaceholderText = (
  isRequired: boolean,
  placeholder?: string,
) => {
  if (placeholder) return placeholder;
  return isRequired ? REQUIRED : OPTIONAL;
};

export const renderFormLabel = (
  name: string,
  label?: string,
  labelComponent?: ReactNode,
) => (
  <>
    {label && <label htmlFor={name}>{label}</label>}
    {labelComponent}
  </>
);

export enum FieldTypes {
  date = "date",
  number = "number",
  select = "select",
  text = "text",
  email = "email",
  password = "password",
  tel = "tel",
}
